import axios from 'axios'

export default (path, data, method, altBaseUrl) => {
    let baseURL = altBaseUrl || `https://api.revolutionplusproperty.com/wp-json/wp/v2`
    let finalPath = `${baseURL}${path}`
    let requestContent = {
        method: method || 'GET',
        url: finalPath,
    }
    if (data && method) {
        requestContent = {
            ...requestContent,
            data: data,
            headers: {
                'Content-Type': 'application/json',
            },
        }
    }
    return axios(requestContent)
}